import React from 'react';
import { FormControl,FormLabel, DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider, DateFnsUtils } from '../../../../third-party-components/material-ui';

class DemoQuestionDate extends React.Component {
    constructor(props) {
        super(props);

        this.handleDateChange = this.handleDateChange.bind(this);
    }
    
    handleDateChange(name, date) {
        const { onChange } = this.props;

        onChange({
            target: {
                name: name,
                value: date
            }
        });
    }

    render() {
        const {name, label, className, value, format, validationMessage, required, disableFuture} = this.props;
        let dateFormat = 'MM/dd/yyyy';
        let selectedDate = null;

        if (format) {
            dateFormat = format;
        }

        if (value !== undefined) {
            selectedDate = new Date(value);
        }

        return (
            <React.Fragment>
                <FormLabel className="demo-error" component="legend" style={{marginBottom:'0.5em'}}>{validationMessage}</FormLabel>
                <FormControl className={`demo-control demo-text ${className}`} component="fieldset">
                    <FormLabel className="demo-label" component="legend">{label}{required && <span className="label-required">*</span>}</FormLabel>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            className="demo-date"
                            autoOk
                            name={name}
                            variant="inline"
                            inputVariant="outlined"
                            disableFuture={disableFuture}
                            format={dateFormat}
                            InputAdornmentProps={{ position: "end" }}
                            value={selectedDate}
                            invalidDateMessage=""
                            onChange={date => this.handleDateChange(name, date)}
                        />
                    </MuiPickersUtilsProvider>
                </FormControl>
            </React.Fragment>
        )
    }
}

export default DemoQuestionDate;